"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = require("../Icon");
var _Text = _interopRequireDefault(require("../Text/Text"));
var _style = require("./style");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const renderContent = channel => {
  const content = {};
  switch (channel) {
    case 'instagram':
      content.Icon = /*#__PURE__*/_react.default.createElement(_Icon.Instagram, null);
      content.name = 'Instagram';
      content.cta = 'Connect an Instagram business account';
      break;
    case 'twitter':
      content.Icon = /*#__PURE__*/_react.default.createElement(_Icon.Twitter, null);
      content.name = 'Twitter';
      content.cta = 'Connect a Twitter profile';
      break;
    case 'facebook':
      content.Icon = /*#__PURE__*/_react.default.createElement(_Icon.Facebook, null);
      content.name = 'Facebook';
      content.cta = 'Connect a Facebook page';
      break;
    case 'pinterest':
      content.Icon = /*#__PURE__*/_react.default.createElement(_Icon.Pinterest, null);
      content.name = 'Pinterest';
      content.cta = 'Connect a Pinterest profile';
      break;
    case 'linkedin':
      content.Icon = /*#__PURE__*/_react.default.createElement(_Icon.LinkedIn, null);
      content.name = 'LinkedIn';
      content.cta = 'Connect a LinkedIn profile';
      break;
    default:
      break;
  }
  return content;
};
const SocialButton = _ref => {
  let {
    disabled,
    channel,
    onClick
  } = _ref;
  const content = renderContent(channel);
  return /*#__PURE__*/_react.default.createElement(_style.SocialButtonStyled, {
    onClick: !disabled ? onClick : undefined,
    channel: channel,
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement(_style.ChannelIconContainerStyled, null, content.Icon, /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "p"
  }, content.name)), /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "p"
  }, content.cta));
};
SocialButton.propTypes = {
  disabled: _propTypes.default.bool,
  channel: _propTypes.default.oneOf(['twitter', 'instagram', 'facebook', 'pinterest', 'linkedin']).isRequired,
  onClick: _propTypes.default.func.isRequired
};
SocialButton.defaultProps = {
  disabled: false
};
var _default = exports.default = SocialButton;